import { I621Form } from 'legacy/lut/features/partner360/configuration'
import { IVerticalMarket } from 'legacy/lut/features/partner360/marketInfo'

export const mapVerticalMarketTo621 = (data: Partial<IVerticalMarket>): Partial<I621Form> => {
  const mapped: Partial<I621Form> = {
    VerticalShowPercent: data.isPercentMode === undefined ? undefined : data.isPercentMode ? 1 : 0,
    VerticalCentralGovernment: data.centralGovernment,
    VerticalEducation: data.education,
    VerticalFinancialServices: data.financialServices,
    VerticalHealthcare: data.healthcare,
    VerticalLocalGovernment: data.localGovernment,
    VerticalManufacturing: data.manufacturing,
    VerticalProfessionalServices: data.professionalServices,
    VerticalRetail: data.retail,
    VerticalTelecommunications: data.telecommunications,
    VerticalTransportation: data.transportation,
    VerticalUtilities: data.utilities,
    VerticalOthers: data.others,
    VerticalOthersComment: data.comment,
  }

  for (const key in mapped) {
    if (mapped[key] === undefined) {
      delete mapped[key]
    }
  }

  return mapped
}
